import { render, staticRenderFns } from "./MedicalDiagnosticLab.vue?vue&type=template&id=b0b50438&"
import script from "./MedicalDiagnosticLab.vue?vue&type=script&lang=js&"
export * from "./MedicalDiagnosticLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports